(function () {
  if (window.__nestThemeV2PdpPriceCommaWrapper20260624) return;
  window.__nestThemeV2PdpPriceCommaWrapper20260624 = true;

  var previousScript = 'theme-v2-before-pdp-price-comma-fix-20260624-no-popup-countdown-loader.js';
  var mrcGateScript = 'mrc-cart-mutation-gate-20260625.js';
  var priceFixScript = 'pdp-variant-price-comma-fix-20260624.js';
  var cartTermsTitleFixScript = 'cart-terms-link-title-fix-20260626.js';

  // The current Extend cart strategy is passive visual suppression. Keep older
  // cart-open/focus gates from also hiding, clicking, or delaying the drawer.
  window.__nestExtendFocusGate = true;
  window.__nestCartOpenSettleGate20260625 = true;

  function assetUrl(filename) {
    var script = document.currentScript;
    if (script && script.src) {
      try {
        return new URL(filename, script.src).toString();
      } catch (error) {}
    }
    return filename;
  }

  function loadScript(src, async) {
    if (document.readyState === 'loading' && async === false) {
      document.write('<script src="' + src.replace(/"/g, '&quot;') + '"><\/script>');
      return;
    }

    var script = document.createElement('script');
    script.src = src;
    script.async = async !== false;
    (document.head || document.documentElement).appendChild(script);
  }

  function installMobileMenuKeyboardControls() {
    if (window.__nestMobileMenuKeyboardControlsInline20260626) return;
    window.__nestMobileMenuKeyboardControlsInline20260626 = true;

    var focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]';
    var sectionHeaderSelector = '.mobile-menu-section-header';
    var topMenuSelector = '#collections-menu > li[id$="-menu-opener"]';
    var menuSelector = '#collections-menu';
    var drawerToggleSelector = '.js-mobile-nav-toggle';

    function ready(callback) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback);
        return;
      }
      callback();
    }

    function isVisible(element) {
      if (!element) return false;
      return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    }

    function rememberAndDisable(control) {
      if (!control) return;
      if (control.getAttribute('data-nest-menu-tabindex') === null) {
        control.setAttribute('data-nest-menu-tabindex', control.getAttribute('tabindex') || '');
      }
      control.setAttribute('tabindex', '-1');
    }

    function restore(control) {
      if (!control || control.getAttribute('data-nest-menu-tabindex') === null) return;
      var previous = control.getAttribute('data-nest-menu-tabindex');
      control.removeAttribute('data-nest-menu-tabindex');
      if (previous === '') control.removeAttribute('tabindex');
      else control.setAttribute('tabindex', previous);
    }

    function setPanelTabStops(panel, enabled) {
      if (!panel) return;
      var controls = panel.querySelectorAll(focusableSelector);
      Array.prototype.forEach.call(controls, function (control) {
        if (control.matches('.visually-hidden.expand-subMenu')) {
          rememberAndDisable(control);
          return;
        }
        if (enabled) restore(control);
        else rememberAndDisable(control);
      });
    }

    function firstFocusable(panel) {
      if (!panel) return null;
      return panel.querySelector('a[href]:not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), input:not([disabled]):not([tabindex="-1"])');
    }

    function setExpanded(control, panel, expanded, forceDisplay) {
      if (control) {
        control.setAttribute('role', control.tagName === 'A' ? 'button' : control.getAttribute('role') || 'button');
        control.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (!control.hasAttribute('tabindex')) control.setAttribute('tabindex', '0');
      }
      if (panel) {
        panel.setAttribute('aria-hidden', expanded ? 'false' : 'true');
        if (forceDisplay) {
          panel.style.display = expanded ? 'block' : 'none';
          panel.style.visibility = expanded ? 'visible' : '';
          panel.style.opacity = expanded ? '1' : '';
        }
      }
      setPanelTabStops(panel, expanded);
    }

    function mobileSectionPanel(header) {
      var section = header && header.closest ? header.closest('.mobile-menu-section') : null;
      if (!section) return null;
      return section.querySelector('.mobile-menu-section-menu');
    }

    function syncMobileSection(header) {
      var panel = mobileSectionPanel(header);
      if (!panel) return false;
      setExpanded(header, panel, isVisible(panel), false);
      return true;
    }

    function toggleMobileSection(header, moveFocus) {
      var panel = mobileSectionPanel(header);
      if (!panel) return false;
      var expanded = header.getAttribute('aria-expanded') === 'true' || isVisible(panel);
      setExpanded(header, panel, !expanded, true);
      if (!expanded && moveFocus) {
        var first = firstFocusable(panel);
        if (first) first.focus();
      }
      return true;
    }

    function topMenuParts(target) {
      var opener = target && target.closest ? target.closest(topMenuSelector) : null;
      if (!opener) return null;
      var link = opener.querySelector(':scope > a[href]');
      var expander = opener.querySelector(':scope > .expand-subMenu');
      var panel = opener.querySelector(':scope > .megamenu');
      if (!panel || !(target === link || target === expander || (link && link.contains(target)) || (expander && expander.contains(target)))) return null;
      return { opener: opener, link: link, expander: expander, panel: panel };
    }

    function closeSiblingTopMenus(current) {
      var root = document.querySelector(menuSelector);
      if (!root) return;
      var openers = root.querySelectorAll(topMenuSelector);
      Array.prototype.forEach.call(openers, function (opener) {
        if (opener === current) return;
        var link = opener.querySelector(':scope > a[href]');
        var expander = opener.querySelector(':scope > .expand-subMenu');
        var panel = opener.querySelector(':scope > .megamenu');
        opener.classList.remove('keyboard-open');
        setExpanded(link, panel, false, true);
        if (expander) expander.setAttribute('aria-expanded', 'false');
      });
    }

    function syncTopMenu(parts) {
      if (!parts) return false;
      var expanded = isVisible(parts.panel);
      parts.link.setAttribute('aria-haspopup', 'true');
      setExpanded(parts.link, parts.panel, expanded, false);
      if (parts.expander) {
        parts.expander.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        rememberAndDisable(parts.expander);
      }
      parts.opener.classList.toggle('keyboard-open', expanded);
      return true;
    }

    function toggleTopMenu(target, moveFocus) {
      var parts = topMenuParts(target);
      if (!parts) return false;
      var expanded = parts.link && parts.link.getAttribute('aria-expanded') === 'true';
      if (!expanded && !isVisible(parts.panel)) expanded = false;
      closeSiblingTopMenus(parts.opener);
      var nextExpanded = !expanded;
      parts.opener.classList.toggle('keyboard-open', nextExpanded);
      setExpanded(parts.link, parts.panel, nextExpanded, true);
      if (parts.expander) parts.expander.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
      if (nextExpanded && moveFocus) {
        var first = firstFocusable(parts.panel);
        if (first) first.focus();
      }
      return true;
    }

    function syncInitialState() {
      var root = document.querySelector(menuSelector);
      if (!root) return;
      Array.prototype.forEach.call(root.querySelectorAll(sectionHeaderSelector), function (header) {
        var panel = mobileSectionPanel(header);
        if (!panel) return;
        setExpanded(header, panel, isVisible(panel), false);
      });
      Array.prototype.forEach.call(root.querySelectorAll(topMenuSelector), function (opener) {
        var link = opener.querySelector(':scope > a[href]');
        var expander = opener.querySelector(':scope > .expand-subMenu');
        var panel = opener.querySelector(':scope > .megamenu');
        if (link && panel) {
          link.setAttribute('aria-haspopup', 'true');
          setExpanded(link, panel, isVisible(panel), false);
        }
        if (expander) rememberAndDisable(expander);
      });
    }

    ready(function () {
      syncInitialState();

      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;

        var sectionHeader = event.target.closest && event.target.closest(sectionHeaderSelector);
        if (sectionHeader) {
          event.preventDefault();
          event.stopPropagation();
          toggleMobileSection(sectionHeader, false);
          return;
        }

        if (topMenuParts(event.target)) {
          event.preventDefault();
          event.stopPropagation();
          toggleTopMenu(event.target, false);
        }
      }, true);

      document.addEventListener('click', function (event) {
        var sectionHeader = event.target.closest && event.target.closest(sectionHeaderSelector);
        if (sectionHeader) {
          window.setTimeout(function () { syncMobileSection(sectionHeader); }, 30);
          return;
        }

        var parts = topMenuParts(event.target);
        if (parts) {
          window.setTimeout(function () { syncTopMenu(parts); }, 30);
        }
      }, false);

      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' && event.key !== 'Esc') return;
        var root = document.querySelector(menuSelector);
        var toggle = document.querySelector(drawerToggleSelector);
        if (!root || !root.contains(event.target)) return;
        event.preventDefault();
        if (toggle) {
          toggle.click();
          toggle.focus();
        }
      }, true);

      document.addEventListener('click', function (event) {
        if (event.target.closest && event.target.closest(drawerToggleSelector)) {
          window.setTimeout(syncInitialState, 30);
        }
      }, false);
    });
  }

  loadScript(assetUrl(mrcGateScript), false);
  loadScript(assetUrl(previousScript), false);
  loadScript(assetUrl(priceFixScript), true);
  loadScript(assetUrl(cartTermsTitleFixScript), true);
  installMobileMenuKeyboardControls();

  function removeKlaviyoBackInStock() {
    if (window.__nestRemoveKlaviyoBackInStock20260701) return;
    window.__nestRemoveKlaviyoBackInStock20260701 = true;

    var notifyPattern = /^\s*notify\s+me(?:\s+when\s+available)?\s*$/i;
    var triggerSelector = [
      '.klaviyo-bis-trigger',
      '[class*="klaviyo"][class*="bis"]',
      '[class*="back-in-stock"]',
      '[data-testid*="back-in-stock"]'
    ].join(',');

    function labelOutOfStock(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var unavailablePrices = scope.querySelectorAll('.variant-price.unavailable');
      Array.prototype.forEach.call(unavailablePrices, function (element) {
        if (notifyPattern.test(element.textContent) || /\$\s*[\d,.]+/.test(element.textContent)) {
          element.textContent = 'Out of Stock';
        }
        element.removeAttribute('role');
        element.removeAttribute('tabindex');
        element.removeAttribute('aria-haspopup');
      });
    }

    function replaceGeneratedTriggers(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var candidates = Array.prototype.slice.call(scope.querySelectorAll(triggerSelector));
      candidates = candidates.concat(Array.prototype.slice.call(scope.querySelectorAll('a, button')));

      candidates.forEach(function (element) {
        if (!element || !element.textContent || !notifyPattern.test(element.textContent)) return;
        element.textContent = 'Out of Stock';
        element.classList.add('variant-price', 'unavailable');
        element.removeAttribute('href');
        element.removeAttribute('role');
        element.removeAttribute('tabindex');
        element.removeAttribute('aria-haspopup');
        element.style.display = '';
        element.style.pointerEvents = 'none';
      });
    }

    function suppressNotifyClick(event) {
      var target = event.target && event.target.closest ? event.target.closest('a, button, .variant-price.unavailable') : null;
      if (!target || !notifyPattern.test(target.textContent || '')) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      labelOutOfStock(document);
      replaceGeneratedTriggers(document);
    }

    function run(root) {
      labelOutOfStock(root);
      replaceGeneratedTriggers(root);
    }

    document.addEventListener('click', suppressNotifyClick, true);
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
      suppressNotifyClick(event);
    }, true);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { run(document); });
    } else {
      run(document);
    }

    var runCount = 0;
    var startupTimer = window.setInterval(function () {
      run(document);
      runCount += 1;
      if (runCount >= 40) window.clearInterval(startupTimer);
    }, 250);

    var observer = new MutationObserver(function () {
      run(document);
    });

    observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }

  removeKlaviyoBackInStock();
})();
